import React from "react";
import styled from "styled-components";
import CSS from "csstype";

export interface ContainerProps {
    paddingTop?: CSS.Property.PaddingTop
    paddingBottom?: CSS.Property.PaddingBottom
    maxWidth?: CSS.Property.MaxWidth
    gap?: CSS.Property.Gap
}

const Container = styled.div<ContainerProps>`
  width: 100%;
  display: flex;
  flex-direction: column;
  max-width: ${props => props.maxWidth ?? "1200px"};
  margin: 0 auto;
  box-sizing: border-box;
  gap: ${props => props.gap ?? 0};
  padding-top: ${props => props.paddingTop ?? "5rem"};
  padding-bottom: ${props => props.paddingBottom ?? "5rem"};
  padding-left: 1rem;
  padding-right: 1rem;
  position: relative;
`

export default Container